import React, { useState, useRef, useEffect } from "react";
import { Carousel } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../src/components/styles/Home.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

import Slider from "../assets/Slider.png";
import bannerslider2 from "../assets/bannerslider2.png";
import Vector from "../assets/Vector.png";
import Mumbai from "../assets/Mumbai.png";
import chani from "../assets/chani.png";
import colkata from "../assets/colkata.png";
import delhi from "../assets/delhi.png";
import hadrabad from "../assets/hadrabad.png";

// import bookapojaevent from "../assets/bookapojaevent.png";
import BookPurohits from "../assets/BookPurohits.png";
import pandits from "../assets/pandits.png"; // Replace with actual images
import pujaserved from "../assets/pujaserved.png";
import Pujatype from "../assets/Pujatype.png";
import curculimage from "../assets/curculimage.png";
import circuit from "../assets/circuit.png";
import chakrvat from "../assets/chakrvat.png";

import Capricorn from "../assets/horoscopes/Capricorn.jpg";
import Pisces from "../assets/horoscopes/Pisces.jpg";
import Sagittarius from "../assets/horoscopes/Sagittarius.jpg";
import Taurus from "../assets/horoscopes/Taurus.jpg";
import aquarius from "../assets/horoscopes/aquarius.jpg";
import aries from "../assets/horoscopes/aries.jpg";
import cancer from "../assets/horoscopes/cancer.jpg";
import gemini from "../assets/horoscopes/gemini.jpg";
import leo from "../assets/horoscopes/leo.jpg";
import libra from "../assets/horoscopes/libra.jpg";
import scorpio from "../assets/horoscopes/scorpio.jpg";
import virgo from "../assets/horoscopes/virgo.jpg";

import locationpng from "../assets/locationpng.png";



import Modal from "react-bootstrap/Modal";
import Footer from "../components/Footer";
import Header from "../components/Header";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import bookpanditimg from '../assets/img_book_pandit.png';
import ganeshji from '../assets/ganesh-5998483_1920 (1) 1.png';

import { useNavigate } from "react-router-dom"; // Import useNavigate
import BookPanditForm from "../components/BookPanditForm";

import BookPanditPopupModal from "../components/BookPanditPopupModal";








import axios from 'axios';


function Home() {
  const navigate = useNavigate(); // Initialize useNavigate

  const handleViewAllClick = (id) => {
    navigate(`/viewall/${id}`); // Navigate to the desired URL with the ID
  };




  // fatching panditllist list 

const [panditllist, setPanditllist] = useState([]);
useEffect(() => {
  const selectedCityId = localStorage.getItem('selectedCityId') || '';
  
  axios
    .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/pandit/`, {
      params: { loc: selectedCityId }
    })
    .then((response) => {
      const panditList = response.data.data.pandit_list || [];
      setPanditllist(panditList);
      console.log("Pandit list fetched successfully:", panditList);
    })
    .catch((err) => {
      console.error("Error fetching pandit list:", err.message);
    });
}, []);


  // this code for current location (city)
const [locationCityName, setLocationCityName] = useState('');
const [locationError, setLocationError] = useState('');
const [locationLoading, setLocationLoading] = useState(false);
const [searchResults, setSearchResults] = useState([]);
const [showSearchResults, setShowSearchResults] = useState(false);
const autocompleteRef = useRef(null);
const [categorys, setCategorys] = useState([]);
const panditScrollRef = useRef(null);


// Initialize autocomplete for city search
useEffect(() => {
  const savedCity = localStorage.getItem('selectedCity');
  if (savedCity) {
    setLocationCityName(savedCity);
  }

  // Load Google Maps script
  if (!window.google) {
    const script = document.createElement('script');
    script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyABI4yscv1eRiRIKARL4vVstB6SKcVWbYo&libraries=places`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);
  }
}, []);

// Initialize autocomplete after script loads
useEffect(() => {
  const initAutocomplete = () => {
    if (window.google && document.getElementById('city-search-input')) {
      const autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById('city-search-input'),
        { types: ['(cities)'] }
      );

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (place.geometry && place.name) {
          const city = place.name;
          setLocationCityName(city);
          localStorage.setItem('selectedCity', city);
          setTimeout(() => setShow(false), 2000);
        }
      });

      autocompleteRef.current = autocomplete;
    }
  };

  const timer = setTimeout(initAutocomplete, 500);
  return () => clearTimeout(timer);
}, []);


// String similarity function for 70% matching
const stringSimilarity = (str1, str2) => {
  const s1 = str1.toLowerCase().trim();
  const s2 = str2.toLowerCase().trim();
  
  const longer = s1.length > s2.length ? s1 : s2;
  const shorter = s1.length > s2.length ? s2 : s1;
  
  if (longer.length === 0) return 100.0;
  
  const editDistance = getEditDistance(longer, shorter);
  return ((longer.length - editDistance) / longer.length) * 100;
};

const getEditDistance = (s1, s2) => {
  const costs = [];
  for (let i = 0; i <= s1.length; i++) {
    let lastValue = i;
    for (let j = 0; j <= s2.length; j++) {
      if (i === 0) {
        costs[j] = j;
      } else if (j > 0) {
        let newValue = costs[j - 1];
        if (s1.charAt(i - 1) !== s2.charAt(j - 1)) {
          newValue = Math.min(Math.min(newValue, lastValue), costs[j]) + 1;
        }
        costs[j - 1] = lastValue;
        lastValue = newValue;
      }
    }
    if (i > 0) costs[s2.length] = lastValue;
  }
  return costs[s2.length];
};

const fetchCityAndStateIds = async (cityName, stateName) => {
  try {
    setLocationLoading(true);
    console.log('Fetching IDs for City:', cityName, 'State:', stateName);

    const statesUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/state/country/101/`;
    console.log('Fetching states from:', statesUrl);
    const statesResponse = await axios.get(statesUrl);
    console.log('States Response:', statesResponse.data);
    
    const statesList = statesResponse.data.state_list || [];
    console.log('States List:', statesList);
    
    
    let foundStateId = null;
    let matchedState = null;
    
    for (let state of statesList) {
      const similarity = stringSimilarity(stateName, state.state_name);
      console.log(`Comparing "${stateName}" with "${state.state_name}" - Similarity: ${similarity}%`);
      
      if (similarity >= 70) {
        foundStateId = state.id;
        matchedState = state;
        console.log('State matched:', state);
        break;
      }
    }
    
    if (!foundStateId) {
      console.error('No state matched with 70% similarity');
      setLocationError('State not found in our database.');
      setLocationLoading(false);
      return;
    }
    

    const citiesUrl = `${process.env.REACT_APP_API_BASE_URL}/api/v1/city/state/${foundStateId}/`;
    console.log('Fetching cities from:', citiesUrl);
    const citiesResponse = await axios.get(citiesUrl);
    console.log('Cities Response:', citiesResponse.data);
    
    const citiesList = citiesResponse.data.city_list || [];
    console.log('Cities List:', citiesList);
    

    let foundCityId = null;
    let matchedCity = null;
    
    for (let city of citiesList) {
      const similarity = stringSimilarity(cityName, city.city_name);
      console.log(`Comparing "${cityName}" with "${city.city_name}" - Similarity: ${similarity}%`);
      
      if (similarity >= 70) {
        foundCityId = city.id;
        matchedCity = city;
        console.log('City matched:', city);
        break;
      }
    }
    
    if (!foundCityId) {
      console.error('No city matched with 70% similarity');
      setLocationError('City not found in our database.');
      setLocationLoading(false);
      return;
    }
    

    console.log('Storing in localStorage:', {
      selectedCity: cityName,
      selectedState: stateName,
      selectedStateId: foundStateId,
      selectedCityId: foundCityId
    });
    
    localStorage.setItem('selectedCity', cityName);
    localStorage.setItem('selectedState', stateName);
    localStorage.setItem('selectedStateId', foundStateId);
    localStorage.setItem('selectedCityId', foundCityId);
    
    setLocationCityName(cityName);
    setLocationError('');
    setTimeout(() => {
  window.location.reload();
}, 1000);
    
  } catch (err) {
    console.error('Error fetching city and state IDs:', {
      message: err.message,
      response: err.response?.data,
      fullError: err
    });
    setLocationError('Failed to fetch city and state information.');
  } finally {
    setLocationLoading(false);
  }
};

const handleSearchCity = async () => {
  if (locationCityName.trim()) {
    await fetchCityAndStateIds(locationCityName.trim(), 'India');
    setTimeout(() => setShow(false), 2000);
  } else {
    setLocationError('Please enter a city name.');
  }
};

  // Search cities API
  const searchCities = async (cityName) => {
    if (!cityName.trim()) {
      setSearchResults([]);
      setShowSearchResults(false);
      return;
    }

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/v1/city/search/`,
        { params: { q: cityName } }
      );

      const cityList = response.data.data?.city_list || [];
      setSearchResults(cityList);
      setShowSearchResults(cityList.length > 0);
      setLocationError('');
    } catch (err) {
      console.error('Error searching cities:', err);
      setLocationError('Failed to search cities.');
      setSearchResults([]);
    }
  };

  // Handle city selection from search results
  const handleCitySelect = (city) => {
    localStorage.setItem('selectedCity', city.city_name);
    localStorage.setItem('selectedCityId', city.id);
    localStorage.setItem('selectedState', city.state_name);
    localStorage.setItem('selectedStateId', city.state_id);
    localStorage.setItem('selectedCountry', city.country_name);
    localStorage.setItem('selectedCountryId', city.country_id);

    setLocationCityName(city.city_name);
    setSearchResults([]);
    setShowSearchResults(false);
    setLocationError('');
    setTimeout(() => {
  setShow(false);
  window.location.reload();
}, 1000);
  };

  // Fetch current location and get city name
  const handleGetCity = async () => {
    setLocationLoading(true);
    setLocationError('');

    if (!navigator.geolocation) {
      setLocationError('Geolocation is not supported by your browser.');
      setLocationLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        try {
          const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyABI4yscv1eRiRIKARL4vVstB6SKcVWbYo`;
          const response = await axios.get(url);

          if (response.data.results && response.data.results.length > 0) {
            const addressComponents = response.data.results[0].address_components;
            let city = '';

            for (let component of addressComponents) {
              if (component.types.includes('locality')) {
                city = component.long_name;
                break;
              }
            }

            if (city) {
              setLocationCityName(city);
              await searchCities(city);
            } else {
              setLocationError('Could not determine city from location.');
            }
          }
        } catch (err) {
          console.error('Geocoding Error:', err);
          setLocationError('Failed to fetch location details.');
        } finally {
          setLocationLoading(false);
        }
      },
      (err) => {
        setLocationError('Error getting location: ' + err.message);
        setLocationLoading(false);
      }
    );
  };


  const [category,setCategory] = useState([]);
  const [pujaalllist,setallPujalist]=useState([]);
  const [location,setLocation]=useState([]);
  const [pujatype, setPujatype] = useState([]);
  const [pujalist, setPujalist] = useState([]);
  const [panditlist, setPanditlist] = useState([]);
  const [selectedCategoryId, setSelectedCategoryId] = useState(""); 
  const [filteredPujaList, setFilteredPujaList] = useState([]); 



  
// Add new state for storing categories with their pujas
const [categoriesWithPujas, setCategoriesWithPujas] = useState([]);







// Replace the old useEffect with this new one
useEffect(() => {

// Fetch all categories
axios
  .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/category`, {
    params: {
      loc: localStorage.getItem('selectedCityId') || ''
    }
  })
  .then((responses) => {
    const categoryList = responses.data.data.category_list || []; // ✅ Access nested data
    setPujatype(categoryList);
    setCategorys(categoryList);
    console.log("category lists", categoryList);

    // Fetch pujas for each category
    const categoriesData = [];

    // categoryList.forEach((category) => {
    //   axios
    //     .get(`${process.env.REACT_APP_API_BASE_URL}/api/v1/puja/category/${category.id}/`)



    //     .then((pujaResponse) => {
    //       categoriesData.push({
    //         ...category,
    //         pujas: pujaResponse.data.data.puja_list || []
    //       });

    //       if (categoriesData.length === categoryList.length) {
    //         setCategoriesWithPujas(categoriesData);
    //         console.log("Categories with Pujas:", categoriesData);
    //       }
    //     })
    //     .catch((err) => {
    //       console.error(`Error fetching pujas for category ${category.id}:`, err.message);
    //     });
    // });



    categoryList.forEach((category) => {

 const cityId = localStorage.getItem("selectedCityId");

const finalCityId =
  cityId &&
  cityId !== "null" &&
  cityId !== "undefined"
    ? cityId
    : "";

Promise.allSettled(

  categoryList.map((category) =>
    axios.get(
      `${process.env.REACT_APP_API_BASE_URL}/api/v1/puja/category/${category.id}/`,
      {
        params: {
          loc: finalCityId,
        },
      }
    )
  )

).then((results) => {

  const categoriesData = [];

  results.forEach((result, index) => {

    if (result.status === "fulfilled") {

      categoriesData.push({
        ...categoryList[index],
        pujas:
          result.value.data?.data?.puja_list || [],
      });

    } else {

      console.log(
        "FAILED CATEGORY",
        categoryList[index].id
      );

    }

  });

  console.log(
    "FINAL CATEGORIES DATA",
    categoriesData
  );

  setCategoriesWithPujas(categoriesData);

});

});



  

  })
  .catch((err) => {
    console.error("Error fetching categories:", err.message);
  });

}, []);


  // Update filtered puja list when selectedCategoryId changes
  useEffect(() => {
    if (selectedCategoryId) {
      // Find pujas for the selected category from categoriesWithPujas
      const selectedCategory = categoriesWithPujas.find(cat => cat.id === parseInt(selectedCategoryId));
      if (selectedCategory) {
        setPujalist(selectedCategory.pujas || []);
      }
    } else {
      // If no category selected, show all pujas from first category or empty
      setPujalist([]);
    }
  }, [selectedCategoryId, categoriesWithPujas]);





  // for luaction slider

  const locations = [
    { img: Vector, text: "Uttarakhand" },
    { img: hadrabad, text: "Hyderabad" },
    { img: Mumbai, text: "Mumbai" },
    { img: delhi, text: "Delhi" },
    { img: colkata, text: "Kolkata" },
    { img: chani, text: "Chennai" },
    { img: Vector, text: "Uttarakhand" },
    { img: hadrabad, text: "Hyderabad" },
    { img: Mumbai, text: "Mumbai" },
    { img: delhi, text: "Delhi" },
    { img: colkata, text: "Kolkata" },
    { img: chani, text: "Chennai" },
  ];

  // Initialize state variables
  const [startIndex, setStartIndex] = useState(0); // Move this above useEffect
  const visibleItems = 6; // Number of items visible at a time

  useEffect(() => {
    const interval = setInterval(() => {
      if (startIndex + visibleItems < locations.length) {
        setStartIndex((prevIndex) => prevIndex + 1);
      } else {
        setStartIndex(0); // Reset to the beginning when reaching the end
      }
    }, 3000); // Adjust the interval time (3000ms = 3 seconds)

    return () => clearInterval(interval); // Cleanup on component unmount
  }, [startIndex, visibleItems, locations.length]);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // Update useEffect for modal display - check localStorage on component mount
useEffect(() => {
  const savedCity = localStorage.getItem('selectedCity');
  if (!savedCity) {
    setShow(true);
  } else {
    setLocationCityName(savedCity);
    setShow(false);
  }
}, []);

  const scrollRef = useRef(null);
  const categoryScrollRef = useRef(null);
  const scroll = (direction) => {
    if (scrollRef.current) {
      const { scrollLeft, clientWidth } = scrollRef.current;
      const scrollAmount = clientWidth / 2; // Adjust scroll speed
      scrollRef.current.scrollTo({
        left:
          direction === "left"
            ? scrollLeft - scrollAmount
            : scrollLeft + scrollAmount,
        behavior: "smooth",
      });
    }
  };
  const cities = [
    { name: "Mumbai", image: Mumbai },
    { name: "Chennai", image: chani },
    { name: "Hyderabad", image: hadrabad },
    { name: "Delhi", image: delhi },
    { name: "Kolkata", image: colkata },
  ];

  const [openIndex, setOpenIndex] = useState(null);
  const faqs = [
    {
      question: "What is Vedic Astrology?",
      answer:
        "Vedic Astrology, also known as Jyotish, is an ancient Indian science that studies the movements and positions of celestial bodies and their influence on human life. It uses a unique system of planetary periods.",
    },
    {
      question: "How can I get my birth chart (Kundli) made?",
      answer:
        "You can subscribe to our newsletter from the homepage or the footer section of our website.",
    },
    {
      question: "What services do you offer?",
      answer:
        "You can edit your billing and shipping address in your account settings under 'Address' section.",
    },
    {
      question: "Can astrology really predict the future?",
      answer:
        "Unfortunately, we do not provide free sample copies. However, you can subscribe to our trial version online.",
    },
  ];
  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleNext = () => {
    if (startIndex + visibleItems < locations.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const handlePrev = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const testimonials = [
    {
      id: 1,
      name: "“An amazing service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description:
        "Lorem ipsum dolor sit ametolil col consectetur adipiscing lectus a nunc mauris scelerisque sed egestas.",
      position: "CEO, Carryminati production house",
      quote: "Ajay Nagar",
    },
    {
      id: 2,
      name: "“One of a kind service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description:
        "Ultrices eros in cursus turpis massa tincidunt sem nulla pharetra diam sit amet nisl suscipit adipis.",
      position: "Developer, THYO India",
      quote: "Deepak Gupta",
    },
    {
      id: 3,
      name: "“The best service”",
      image: require("../assets/pandits.png"), // ✅ Fixed
      description:
        "Convallis posuere morbi leo urna molestie at elementum eu facilisis sapien pellentesque habitant.",
      position: "CEO, Carryminati production house",
      quote: "Rajiv Ranjan",
    },
  ];




  const [isMobile, setIsMobile] = useState(false);

  // Detect screen size
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768); // Check if the screen width is 768px or smaller
    };

    handleResize(); // Initial check
    window.addEventListener("resize", handleResize); // Add event listener for window resize

    return () => window.removeEventListener("resize", handleResize); // Cleanup on component unmount
  }, []);

  return (
    <>
      <Header />
      <section className=" mt-md-5 mt-3 ">
        {/* Top Icons Section */}
        <div className="d-none d-md-block">
          <div className="px-3 center12 container ">
            {/*  before px-5 */}
            {categorys.map((item, index) => (
  <div key={index} className="text-center12 icon-item">
    <a href={"/"} className="text-decoration-none">
      <img
        src={item.category_image}
        alt="Ez Puja Path"
        className="img-fluid icon-img mt-lg-4"
        style={{ width: "80px", height: "80px", objectFit: "contain", borderRadius:'50%' }}
      />
      <h4 className="icon-text">{item.category_name}</h4>
    </a>
  </div>
))}
          </div>
        </div>
        {/* Carousel Section */}
        <div className="mt-md-4 mt-4">
          <Carousel fade>
            <Carousel.Item>
              <img
                className="img-fluid d-block w-100"
                src={bannerslider2}
                alt="First slide"
                style={{ maxHeight: "80vh", objectFit: "cover" }}
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="img-fluid d-block w-100"
                src={bannerslider2}
                alt="Second slide"
                style={{ maxHeight: "80vh", objectFit: "cover" }}
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
            <Carousel.Item>
              <img
                className="img-fluid d-block w-100"
                src={Slider}
                alt="Third slide"
                style={{ maxHeight: "80vh", objectFit: "cover" }}
              />
              <Carousel.Caption></Carousel.Caption>
            </Carousel.Item>
          </Carousel>
        </div>

        {/* for phone */}

        {/* Top Icons Section */}

        <div className="d-block d-md-none center12forphone">
          <div className="px-3 center12 container">
            <div 
              ref={categoryScrollRef}
              className="d-flex flex-nowrap"
              style={{
                overflowX: 'auto',
                scrollBehavior: 'smooth',
                gap: '10px',
                paddingBottom: '10px',
                scrollbarWidth: 'none',
                msOverflowStyle: 'none',
              }}
            >
            {categorys.map((item, index) => (
  <div 
    key={index} 
    className="text-center12 icon-item pt-2"
    style={{
      flex: '0 0 calc(33.333% - 7px)',
      minWidth: 'calc(33.333% - 7px)',
    }}
  >
    <a href={"/"} className="text-decoration-none">
      <div>
        <img
          src={item.category_image}
          alt="Ez Puja Path"
          className="icon-img"
          style={{ width: '80px', height: '80px', objectFit: 'contain', borderRadius:'50%' }}
        />
      </div>
      <h4 className="icon-text text-white" style={{ fontSize: '12px', marginTop: '8px' }}>
        {item.category_name}
      </h4>
    </a>
  </div>
))}
            </div>
          </div>
        </div>

     
        <div
          style={{ backgroundColor: "#6B2A00", padding: "20px" }}
          className="d-none d-md-block"
        >
          <div className="container d-flex align-items-center justify-content-between responss">
            <h3 className="text-white responsi ">
              {" "}
              <span style={{ fontSize: "23px", fontWeight: "200" }}>
                We are
              </span>
              <br />
              Available In
            </h3>
            <div
              className="d-flex align-items-center w-100 position-relative"
              style={{ overflow: "hidden" }}
            >
              <div
                className="d-flex gap-2 flex-nowrap"
                style={{ overflow: "hidden" }}
              >
                {locations
                  .slice(startIndex, startIndex + visibleItems)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="d-flex flex-column align-items-center justify-content-center availebl"
                    >
                      <img
                        src={item.img}
                        alt="icon-png"
                        className="img-fluid"
                        style={{ height: "60px", objectFit: "contain" }}
                      />
                      <h4
                        className="mt-2 text-center"
                        style={{ color: "#000000", fontSize: "18px" }}
                      >
                        {item.text}
                      </h4>
                    </div>
                  ))}
              </div>
              <div
                className="d-flex flex-column align-items-center  gap-3"
                style={{ marginLeft: "19px" }}
              >
                <button
                  onClick={handlePrev}
                  className="btn  "
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "30px",
                    opacity: "1",
                    padding: "4px 10px 7px 10px",
                  }}
                  disabled={startIndex === 0}
                >
                  <FaArrowLeft />
                </button>
                <button
                  onClick={handleNext}
                  className="btn  "
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "30px",
                    opacity: "1",
                    padding: "4px 10px 7px 10px",
                  }}
                  disabled={startIndex + visibleItems >= locations.length}
                >
                  <FaArrowRight />
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* for phone */}

        <div style={{ padding: "20px" }} className="d-block d-md-none">
          <div className=" d-flex align-items-center justify-content-between responss">
            <h3 className="responsi" style={{ color: "#E3952A" }}>
              We are Available In
            </h3>
            <div
                style={{
                  width: "100%",
                  height: "3px",
                  marginTop: "5px",
                  background:
                    "linear-gradient(to right, #8B5E3B 60%, #D3B8A1 20%)",
                }}
              ></div>
            <div
              className="d-flex align-items-center w-100 position-relative"
              style={{ overflow: "hidden" }}
            >
              <div
                className="d-flex gap-2 flex-nowrap"
                style={{ overflow: "hidden" }}
                ref={scrollRef}
              >
                {locations
                  .slice(startIndex, startIndex + visibleItems)
                  .map((item, index) => (
                    <div
                      key={index}
                      className="d-flex flex-column align-items-center justify-content-center availebl"
                    >
                      <img
                        src={item.img}
                        alt="icon-png"
                        className="img-fluid"
                        style={{ height: "60px", objectFit: "contain" }}
                      />
                      <h4
                        className="mt-2 text-center"
                        style={{ color: "#000000", fontSize: "18px" }}
                      >
                        {item.text}
                      </h4>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>



{/* Dynamic Sections based on Categories */}
{categoriesWithPujas.map((categoryData, index) => (
  <section key={index} className="mt-4">
    <div
      style={{ position: "relative", paddingBottom: "10px" }}
      className="container"
    >
      <div className="d-flex flex-column">
        <div className="d-flex justify-content-between align-items-center flex-wrap">
          <h3
            style={
              isMobile
                ? { color: "#E3952A", fontSize: "24px", fontWeight: "400" }
                : { color: "#6B2A00", fontSize: "24px" }
            }
          >
            {categoryData.category_name}
          </h3>
          <h3
            style={{
              color: "#E3952A",
              fontSize: "16px",
              cursor: "pointer",
            }}
            onClick={() => handleViewAllClick(categoryData.id)}
          >
            View All <i className="fas fa-chevron-right"></i>
          </h3>
        </div>

        <p
          style={{
            color: "#E3952A",
            fontSize: "16px",
            marginTop: "5px",
            marginBottom: "5px",
          }}
          className="d-none d-md-block"
        >
          Explore our curated collection of puja services.
        </p>

        <div
          style={{
            width: "100%",
            height: "2px",
            marginTop: "5px",
            background:
              "linear-gradient(to right, #8B5E3B 20%, #D3B8A1 20%)",
          }}
        ></div>
      </div>
    </div>

    <div className="container d-flex justify-content-evenly flex-wrap gap-3 m-auto mt-4">
      {categoryData.pujas.slice(0, 4).map((puja, pujaIndex) => (
        <div key={pujaIndex} className="event-card">
          <img
            src={puja.puja_image}
            alt={puja.puja_name}
            className="event-img"
          />
          <div className="event-content">
            <h2>{puja.puja_name}</h2>
            <p>{puja.description}</p>
            <button className="botton"  onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal",
        {
          detail: {
            pujaId: puja.id
          }
        }
      )
    );

  }}
>Book A Pandit Today!</button>
          </div>
        </div> 
      ))}
    </div>
  </section>
))}


    

        {/* book your pandit  */}

        <div className="mt-5 img_book_pandit d-none d-lg-block">

          <button
            className="btn botton  w-25 m-auto"
            style={{
              position: "relative",
              bottom: "-380px",
              left: "38%",
              // transform: "translateX(-50%)",
              textAlign: "center",
            }}

             onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
          >
            Book a Puja for your special occasion today!
          </button>{" "}
        </div>

        {/* for phone */}

        <div className="mt-5 d-block d-md-none">
          <img src={bookpanditimg} alt="" className=" img-fluid w-100" />
        </div>

   



        <section
          className="position-relative text-white py-5 d-flex align-items-center mt-5 d-none d-md-block"
          style={{
            backgroundImage: `url(${BookPurohits})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div className="container p-3 p-sm-5">
            <div className="row align-items-center text-center text-sm-start">
              {/* Left Side: Heading & CTA Button */}
              <div className="col-12 col-md-4 mb-4 mb-md-0">
                <h2 className="display-6">
                  Avail our services and benefit yourselves!
                </h2>
                <a
  className="botoun d-inline-block mt-2 text-decoration-none text-yellow fw-bold"
  style={{ color: "#E3952A", cursor: "pointer" }}  onClick={() => {
    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
>
  Book A Pandit Today!
</a>
              </div>
              {/* Right Side: Service Cards */}
              <div className="col-12 col-md-7 offset-md-1">
                <div className="row g-3">
                  {[
                    {
                      img: Pujatype,
                      title: "251+ Puja Type",
                      desc: "Choose from a wide range of over 251+ Puja types.",
                    },
                    {
                      img: pandits,
                      title: "150+ Pandits",
                      desc: "With a team of 150+ expert Pandits.",
                    },
                    {
                      img: pujaserved,
                      title: "2100+ Puja Served",
                      desc: "Over 2100+ pujas performed, each bringing divine blessings to our clients.",
                    },
                  ].map((item, index) => (
                    <div key={index} className="col-12 col-sm-6 col-md-4">
                      <div className="p-3 border rounded text-center bg-opacity-20 divautt">
                        <img
                          src={item.img}
                          alt={item.title}
                          className="img-fluid mx-auto mb-3"
                          style={{ objectFit: "contain", maxHeight: "100px" }}
                        />
                        <h3 className="h5" style={{ fontSize: "18px" }}>
                          {item.title}
                        </h3>
                        <p className="small">{item.desc}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* for phone  */}

        <div className="container benifitcontainer w-100 mt-5 img-fluid d-block d-md-none d-flex">
          <div className="row">
            <div className="col-5">
              <h1
                style={{ fontSize: "14px", fontWeight: "600", color: "white" }}
              >
                Avail our services and <br></br> benefit yourselves!
              </h1>
              <button>Book A Pandit Today!</button>
            </div>
            <div className="col-7 d-flex align-items-center text-center gap-1">
              <div style={{ border: "1px solid white" }} className=" rounded-2">
                <img src={Pujatype} alt="" style={{ width: "60px" }} />
                <h1
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  251+{" "}
                </h1>
                <h1
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  Puja Type
                </h1>
              </div>
              <div style={{ border: "1px solid white" }} className=" rounded-2">
                <img src={Pujatype} alt="" style={{ width: "60px" }} />
                <h1
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  251+{" "}
                </h1>
                <h1
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  Puja Type
                </h1>
              </div>
              <div style={{ border: "1px solid white" }} className=" rounded-2">
                <img src={Pujatype} alt="" style={{ width: "60px" }} />
                <h1
                  style={{
                    fontSize: "12px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  251+{" "}
                </h1>
                <h1
                  style={{
                    fontSize: "11px",
                    fontWeight: "500",
                    color: "white",
                  }}
                >
                  Puja Type
                </h1>
              </div>
            </div>
          </div>
        </div>

        <section className="mt-5">
          <div className="container p-3">
            <div className="row align-items-center">
              {/* Left Side: Heading & CTA Button */}
              <div className="col-sm-5  text-center text-sm-start mb-4 mb-sm-0">
                <img
                  src={curculimage}
                  alt="Puja Type"
                  className="mx-auto mb-3"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                  }}
                />
              </div>
              {/* Right Side: Service Cards */}
              <div className="col-sm-7">
                <p className="headercolor">PERSONAL CONSULTATION</p>

                <p className="ptextcolor">
                  Our Personal Consultation service offers one-on-one sessions
                  with expert Pandits to provide personalized spiritual guidance
                  for your life s most important events. Whether its for puja
                  ceremonies, astrological advice, or resolving any life
                  challenges, we are here to offer the support you need.
                </p>
                <div>
                  <div className="d-none d-md-block">
                    <p className="ptextcolor1">
                      {" "}
                      🔹
                      <span className="ptextcolor2">
                        Customized Solutions{" "}
                      </span>{" "}
                      based on your specific needs
                    </p>
                    <br />
                    <p className="ptextcolor1">
                      🔹<span className="ptextcolor2">Expert Guidance </span> on
                      Vedic rituals and spiritual practices
                    </p>
                    <br />
                    <p className="ptextcolor1">
                      🔹<span className="ptextcolor2">Personalized Puja </span>{" "}
                      Planning to ensure maximum blessings
                    </p>

                    {/* <button className="ptextcolor2 mt-5"></button> */}
                    {/* <button className="botton w-25">Get Start</button> */}
                  </div>

                  {/* for phone */}

                  <div className="d-block d-md-none ">
                    <p>
                      <span className="ptextcolor2 ">
                        🔹 Customized Solutions
                      </span>
                      <span className="ptextcolor2">🔹 Expert Guidance </span>
                      <span className="ptextcolor2">🔹 Expert Guidance </span>
                    </p>

                  </div>

                  <div className="d-none d-md-block">
                    <a
                      type="button"
                      class="btn w-25 botton "
                     onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
                    >
                      Get Start
                    </a>
                  </div>
                  <div className="d-block d-md-none text-center personal_button2 ">
                    <a
                      type="button"
                      class="btn  "
                   onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
                    >
                      Get Start
                    </a>
                  </div>

                  <div
                    class="modal fade"
                    id="exampleModal"
                    tabindex="-1"
                    aria-labelledby="exampleModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel">
                            New message
                          </h5>
                          <button
                            type="button"
                            class="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                          ></button>
                        </div>
                        <div class="modal-body">
                          <form>
                            <div class="mb-3">
                              <label
                                for="recipient-name"
                                class="col-form-label"
                              >
                                Recipient:
                              </label>
                              <input
                                type="text"
                                class="form-control"
                                id="recipient-name"
                              />
                            </div>
                            <div class="mb-3">
                              <label for="message-text" class="col-form-label">
                                Message:
                              </label>
                              <textarea
                                class="form-control"
                                id="message-text"
                              ></textarea>
                            </div>
                          </form>
                        </div>
                        <div class="modal-footer">
                          {/* <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button> */}
                          <button type="button" class="btn btn-primary botton ">
                            Send message
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="container p-3">
            <div className="row align-items-center">
            <div className="col-sm-4  text-center text-sm-start mb-4 mb-sm-0 order-lg-1">
                <img
                  src={circuit}
                  alt="Puja Type"
                  className="mx-auto mb-3"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                  }}
                />
              </div>
              <div className="col-sm-8 order-lg-0">
                <p className="headercolor">Circuit Divination</p>
                <p className="ptextcolor">
                  Circuit Divination is an ancient spiritual practice that uses
                  a unique set of rituals and tools to gain insights into your
                  life’s path. It combines divine energy, intuition, and cosmic
                  forces to reveal hidden truths and guide you towards making
                  informed decisions.
                </p>
                <div className="d-none d-md-block">
                    <p className="ptextcolor1">
                      {" "}
                      🔹
                      <span className="ptextcolor2">
                        Customized Solutions{" "}
                      </span>{" "}
                      based on your specific needs
                    </p>
                    <br />
                    <p className="ptextcolor1">
                      🔹<span className="ptextcolor2">Expert Guidance </span> on
                      Vedic rituals and spiritual practices
                    </p>
                    <br />
                    <p className="ptextcolor1">
                      🔹<span className="ptextcolor2">Personalized Puja </span>{" "}
                      Planning to ensure maximum blessings
                    </p>

                    {/* <button className="ptextcolor2 mt-5"></button> */}
                    {/* <button className="botton w-25">Get Start</button> */}
                  </div>

                  {/* for phone */}

                  <div className="d-block d-md-none ">
                    <p>
                      <span className="ptextcolor2 ">
                        🔹 Customized Solutions
                      </span>
                      <span className="ptextcolor2">🔹 Expert Guidance </span>
                      <span className="ptextcolor2">🔹 Expert Guidance </span>
                    </p>

                  </div>

                  <div className="d-none d-md-block">
                    <a
                      type="button"
                      class="btn w-25 botton "
                    onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
                    >
                      Get Start
                    </a>
                  </div>
                  <div className="d-block d-md-none text-center personal_button2 ">
                    <a
                      type="button"
                      class="btn  "
                    onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
                    >
                      Get Start
                    </a>
                  </div>
              </div>
          
            </div>
          </div>
          <div className="container p-3">
            <div className="row align-items-center">
              {/* Left Side: Heading & CTA Button */}
              <div className="col-sm-5  text-center text-sm-start mb-4 mb-sm-0">
                <img
                  src={chakrvat}
                  alt="Puja Type"
                  className="mx-auto mb-3"
                  style={{
                    objectFit: "contain",
                    width: "100%",
                    height: "auto",
                  }}
                />
              </div>
              {/* Right Side: Service Cards */}
              <div className="col-sm-7">
                <p className="headercolor">Making Up a Horoscope</p>
                <p className="ptextcolor">
                  Creating a personalized horoscope is an insightful way to
                  understand the alignment of celestial bodies and how they
                  influence your life. Using your birth details, we craft a
                  detailed chart that provides guidance on your personality,
                  relationships, career, and more.
                </p>
                <div className="d-none d-md-block">
                    <p className="ptextcolor1">
                      {" "}
                      🔹
                      <span className="ptextcolor2">
                        Customized Solutions{" "}
                      </span>{" "}
                      based on your specific needs
                    </p>
                    <br />
                    <p className="ptextcolor1">
                      🔹<span className="ptextcolor2">Expert Guidance </span> on
                      Vedic rituals and spiritual practices
                    </p>
                    <br />
                    <p className="ptextcolor1">
                      🔹<span className="ptextcolor2">Personalized Puja </span>{" "}
                      Planning to ensure maximum blessings
                    </p>

                    {/* <button className="ptextcolor2 mt-5"></button> */}
                    {/* <button className="botton w-25">Get Start</button> */}
                  </div>

                  {/* for phone */}

                  <div className="d-block d-md-none ">
                    <p>
                      <span className="ptextcolor2 ">
                        🔹 Customized Solutions
                      </span>
                      <span className="ptextcolor2">🔹 Expert Guidance </span>
                      <span className="ptextcolor2">🔹 Expert Guidance </span>
                    </p>

                  </div>

                  <div className="d-none d-md-block">
                    <a
                      type="button"
                      class="btn w-25 botton "
                    onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
                    >
                      Get Start
                    </a>
                  </div>
                  <div className="d-block d-md-none text-center personal_button2 ">
                    <a
                      type="button"
                      class="btn  "
                     onClick={() => {

    window.dispatchEvent(
      new CustomEvent(
        "openBookPanditModal"
      )
    );

  }}
                    >
                      Get Start
                    </a>
                  </div>
              </div>
            </div>
          </div>
        </section>
  
        <section style={{ backgroundColor: "#FFFAE8" }}>
          {/* DAILY HOROSCOPES SECTION */}
          <section
            className="position-relative text-white py-5 d-flex align-items-center mt-5"
            style={{ backgroundColor: "#6B2A00" }}
          >
            <div className="container p-3 p-md-5">
              <div className="text-center mb-4 py-1">
                <span className="botoun22 d-block fs-4 p-2">DAILY HOROSCOPES</span>
                <h2 className="displa p-3 fs-1">
                  Daily horoscopes are like a guiding light{" "}
                  <br className="d-none d-md-block" />
                  in the vast universe of possibilities.
                </h2>
              </div>
              <div className="d-flex justify-content-center flex-wrap align-items-center ">
                {[
                  { img: aries, title: "Aries", date: "Feb 17-Mar 16" },
                  { img: Taurus, title: "Taurus", date: "Mar 17-Apr 16" },
                  { img: gemini, title: "Gemini", date: "Apr 17-May 16" },
                  { img: cancer, title: "Cancer", date: "May 17-Jun 16" },
                  { img: leo, title: "Leo", date: "Jun 17-Jul 16" },
                  { img: virgo, title: "Virgo", date: "Jul 17-Aug 16" },
                  { img: libra, title: "Libra", date: "Aug 17-Sep 16" },
                  { img: scorpio, title: "Scorpio", date: "Sep 17-Oct 16" },
                  {
                    img: Sagittarius,
                    title: "Sagittarius",
                    date: "Oct 17-Nov 16",
                  },
                  { img: Capricorn, title: "Capricorn", date: "Nov 17-Dec 16" },
                  { img: aquarius, title: "Aquarius", date: "Dec 17-Jan 16" },
                  { img: Pisces, title: "Pisces", date: "Jan 17-Feb 16" },
                ].map((item, index) => (
                  <div
                    key={index}
                    className="col-6 col-md-4 col-lg-2 mt-4 d-flex flex-column align-items-center"
                  >
                    <div
                      className="p-3 text-center  rounded shadow car2onee "
                      style={{ width: "140px" }}
                    >
                      <img
                        src={item.img}
                        alt={item.title}
                        className="img-fluid mx-auto mb-2"
                        style={{ height: "80px", objectFit: "contain" }}
                      />
                      <h3 className="ariscolor">{item.title}</h3>
                      <p className="ariscolor">{item.date}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          {/* OUR ASTROLOGERS SECTION */}
 

<section className="position-relative text-white py-5 d-flex align-items-center mt-5">
  <div className="container p-3 p-md-5">
    <div className="text-center mb-4 py-1">
      <span className="botoun33 d-block">Our Astrologers</span>
      <h2 className="displaa  fs-1">
        Our astrologers are like guides pointing{" "}
        <br className="d-none d-md-block" />
        the way to understanding the universe.
      </h2>
    </div>
    
    <div className="container py-4 position-relative">
      <button
        className="btn priimary position-absolute start-0 top-50 translate-middle-y d-none d-md-block"
        onClick={() => panditScrollRef.current?.scrollBy({ left: -300, behavior: 'smooth' })}
        style={{
          zIndex: 10,
          backgroundColor: '#6B2A00',
          color: 'white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: 0
        }}
      >
        ❮
      </button>

      <div
        ref={panditScrollRef}
        className="d-flex overflow-auto"
        style={{
          scrollBehavior: "smooth",
          scrollbarWidth: "none",
          gap: "20px",
          paddingLeft: "10px",
          paddingRight: "10px"
        }}
      >
        {panditllist.map((pandit, index) => (
          <div 
            key={index} 
            className="card_container2"
            style={{
              flex: "0 0 calc(25% - 15px)",
              minWidth: "280px",
              maxWidth: "300px"
            }}
          >
            <img
              src={pandit.photo}
              alt={pandit.name}
              className="rounded mx-auto d-block"
              style={{ 
                height: '250px', 
                objectFit: 'cover', 
                width: '100%',
                borderRadius: '10px'
              }}
            />
            {/* <h3 className="ms-auto mt-3">Chat Now</h3> */}
            <div style={{ margin: "12px", textAlign: "justify" }}>
              <h1 style={{ fontSize: '18px', fontWeight: '600', color: '#6B2A00' }}>
                {pandit.name}
              </h1>
              <p style={{ fontSize: '13px', color: '#555', marginBottom: '10px' }}>
                {pandit.description.substring(0, 100)}...
              </p>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h2 style={{ fontSize: '16px', marginBottom: 0 }}>
                  ⭐ {pandit.experience} Yrs
                </h2>
                <p style={{ fontSize: '14px', color: '#E3952A', marginBottom: 0 }}>
                  ₹{pandit.dakshina}
                </p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button
        className="btn priimary position-absolute end-0 top-50 translate-middle-y d-none d-md-block"
        onClick={() => panditScrollRef.current?.scrollBy({ left: 300, behavior: 'smooth' })}
        style={{
          zIndex: 10,
          backgroundColor: '#6B2A00',
          color: 'white',
          borderRadius: '50%',
          width: '40px',
          height: '40px',
          padding: 0
        }}
      >
        ❯
      </button>
    </div>

    {panditllist.length === 0 && (
      <div className="text-center">
        <p>No pandits available for your city</p>
      </div>
    )}


  </div>
</section>

          {/* new section start */}
          <div className="new_section_img d-flex justify-content-start pt-5 p-5 d-none d-lg-block">
            <div className="p-2">
              <h1>Become a Pandit with Us!</h1>
              <p>
                Are you a skilled Pandit ready to serve devotees? Join our
                platform to connect with people seeking authentic Vedic rituals
                and puja services!
              </p>
              <h1>Why Join Us?</h1>
              <p>✅ Wider Reach ✅ Flexible Scheduling ✅ Fair Earnings</p>
              <h1>Who Can Apply?</h1>
              <p>
                ✔️ Experienced in Vedic rituals & pujas✔️ Proficient in Sanskrit
                mantras & traditions✔️ Conducts online & offline pujas
              </p>
         <span
  style={{
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  }}
>
  <a
    href="https://app.ezpujapaath.com/RegisterPandit"
    className="botton"
    target="_blank"
    rel="noopener noreferrer"
    style={{
      textDecoration: "none",
      cursor: "pointer",
    }}
  >
    Join us today!
  </a>
</span>
            </div>
          </div>



          <section className="ko-faq-section">
            <div className="ko-container">
              <div className="text-center mb-4 py-1">
                <span className="botoun44 d-block" style={isMobile?{backgroundColor:"#6B2A00", color:"white"} : {}}>FAQS</span>
                <h2 className="displa1a">Frequently Asked Questions</h2>
              </div>
              <div className="ko-faq-accordion">
                {faqs.map((faq, index) => (
                  <div key={index} className="ko-accordion-item">
                    <div
                      className={`ko-accordion-item-header ${
                        openIndex === index ? "active" : ""
                      }`}
                      onClick={() => toggleFAQ(index)}
                    >
                      {faq.question}
                      <i
                        className={`fas ${
                          openIndex === index
                            ? "fa-chevron-up"
                            : "fa-chevron-down"
                        }`}
                      ></i>
                    </div>
                    <div
                      className="ko-accordion-item-body"
                      style={{
                        maxHeight: openIndex === index ? "200px" : "0px",
                      }}
                    >
                      <p className="ko-accordion-item-body-content">
                        {faq.answer}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
          <section className="py-5 bg-light">
            <div className="container">
              {/* Section Header */}
              <div className="text-center mb-4">
                <span className="text-uppercase testinaction">
                  Testimonials
                </span>
                <h2 className="fboldtext">What our clients say</h2>
              </div>

              {/* Bootstrap Grid - 2 Rows, 3 Columns Each */}
              <div className="row g-4">
                {testimonials.map((testimonial) => (
                  <div key={testimonial.id} className="col-md-4 ">
                    <div className="card border-1 shadow-sm p-5 rounded-4">
                      <div className="">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="rounded-circle me-3"
                          width="60"
                          height="60"
                          style={{
                            objectFit: "cover",
                            border: "1px solid black",
                          }}
                        />
                        <h5 className="textiname mb-3 mt-3">
                          {testimonial.name}
                        </h5>
                        <p className="psmaltext small mb-2">
                          {testimonial.description}
                        </p>
                      </div>

                      <blockquote className="mt-3 textinaeme">
                        {testimonial.quote}
                      </blockquote>
                      <p className="psmaltext small mb-0">
                        {testimonial.position}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </section>
        </section>

        <div className="text-center align-items-center justify-content-center d-flex d-md-none">

  
<img src={ganeshji} alt="" className=" img-fluid " />
</div>
        <div className={isMobile ? "bg-white" : "Container_img img-fluid"}>


        <BookPanditForm />
        <ToastContainer />

        </div>
        {/* model added */}

        <Modal show={show} onHide={handleClose} backdrop="static" keyboard={false} centered>
          <Modal.Header closeButton className="border-0 pb-0">
            <Modal.Title></Modal.Title>
          </Modal.Header>
          <Modal.Body className="pt-2">
            <div className="d-flex justify-content-center model_container align-items-center gap-3 p-3">
              <img src={locationpng} alt="location" style={{ width: '60px', height: '60px' }} />
              <div>
                <h5 className="mb-1" style={{ fontWeight: '600', color: '#6B2A00' }}>Select Your Location</h5>
                <p className="mb-0" style={{ fontSize: '14px', color: '#666' }}>
                  Enable location access to find the nearest pandit and book your puja with ease!
                </p>
              </div>
            </div>
            
            <hr className="my-3" />
            
            <div className="model_container2 px-3 pb-3">
              <div className="mb-3">
                <div className="input-group" style={{ overflow: 'hidden' }}>
                  <input
                    id="city-search-input"
                    type="text"
                    placeholder="Enter Your City"
                    className="form-control border-0"
                    value={locationCityName}
                    onChange={(e) => {
                      setLocationCityName(e.target.value);
                      searchCities(e.target.value);
                    }}
                    style={{ padding: '10px 12px', fontSize: '14px' }}
                  />
                  <button
                    className="btn btn-sm"
                    type="button"
                    onClick={() => searchCities(locationCityName)}
                    style={{ backgroundColor: '#E3952A', color: 'white', border: 'none', padding: '8px 15px' }}
                  >
                    <i className="fa-solid fa-magnifying-glass"></i>
                  </button>
                </div>

                {/* Search Results Dropdown */}
                {showSearchResults && searchResults.length > 0 && (
                  <div 
                    style={{
                      border: '1px solid #ddd',
                      borderTop: 'none',
                      maxHeight: '200px',
                      overflowY: 'auto',
                      backgroundColor: 'white'
                    }}
                  >
                    {searchResults.map((city) => (
                      <div
                        key={city.id}
                        onClick={() => handleCitySelect(city)}
                        style={{
                          padding: '10px 12px',
                          borderBottom: '1px solid #eee',
                          cursor: 'pointer',
                          fontSize: '14px',
                          transition: 'background-color 0.2s'
                        }}
                        onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#f5f5f5'}
                        onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'white'}
                      >
                        <div style={{ fontWeight: '500' }}>{city.city_name}</div>
                        <div style={{ fontSize: '12px', color: '#666' }}>
                          {city.state_name}, {city.country_name}
                        </div>
                      </div>
                    ))}
                  </div>
                )}
              </div>

              <button
                className="btn w-100"
                onClick={handleGetCity}
                disabled={locationLoading}
                style={{
                  backgroundColor: '#6B2A00',
                  color: 'white',
                  border: 'none',
                  padding: '10px',
                  borderRadius: '8px',
                  fontSize: '14px',
                  fontWeight: '500',
                }}
              >
                <i className="fa-solid fa-location-crosshairs pe-2"></i>
                {locationLoading ? 'Getting Location...' : 'Use Current Location'}
              </button>

              {locationError && (
                <div className="alert alert-danger mt-3 mb-0" style={{ fontSize: '13px' }}>
                  <i className="fa-solid fa-circle-exclamation pe-2"></i>
                  {locationError}
                </div>
              )}
            </div>

            <hr className="my-3" />

            <div className="px-3 pb-3">
              <h6 style={{ fontWeight: '600', color: '#6B2A00', marginBottom: '15px' }}>
                We are available in
              </h6>
              <div className="city-container" style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))', gap: '12px' }}>
                {cities.map((city, index) => (
                  <div
                    key={index}
                    className="city-card"
                    onClick={() => {
                      setLocationCityName(city.name);
                      searchCities(city.name);
                    }}
                    style={{
                      cursor: 'pointer',
                      textAlign: 'center',
                      padding: '12px',
                      borderRadius: '8px',
                      border: '2px solid #f0f0f0',
                      transition: 'all 0.3s ease',
                    }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.borderColor = '#E3952A';
                      e.currentTarget.style.backgroundColor = '#fff9f0';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.borderColor = '#f0f0f0';
                      e.currentTarget.style.backgroundColor = 'white';
                    }}
                  >
                    <img
                      src={city.image}
                      alt={city.name}
                      className="city-image"
                      style={{ width: '50px', height: '50px', marginBottom: '8px', objectFit: 'contain' }}
                    />
                    <p className="city-name mb-0" style={{ fontSize: '13px', fontWeight: '500', color: '#333' }}>
                      {city.name}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </section>
      <Footer />
<BookPanditPopupModal />

    </>
  );
}

export default Home;
